import { UrlSegment, UrlMatchResult } from '@angular/router';

const WHITELIST_HTML_PATHS: string[] = [
  'policy.html',
  'user_withdrawal.html',
  'naver4047e50889ec8b213d1f003d652c43be.html',
];

export function legacyHtmlMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length === 0) {
    return null;
  }

  const lastSegment = segments[segments.length - 1].path;
  const fullPath = segments.map(s => s.path).join('/');

  const isWhitelisted = WHITELIST_HTML_PATHS.some(
    whitelisted => lastSegment === whitelisted || fullPath === whitelisted
  );

  if (lastSegment.endsWith('.html') && !isWhitelisted) {
    return { consumed: segments };
  }

  return null;
}